export default __webpack_public_path__ + "static/media/Vector(1).3c2f3d1c.svg";